import { useEffect } from "react";
import { useHasAccess } from "../../../hooks/useHasAccess";
import {
  makeUrl,
  navigate,
  Route,
  routes,
  Switch,
  useCurrentUrl,
  useRouteMatch,
} from "../../../lib/urls";
import { ButtonLink } from "../../Button/ButtonLink";
import { TabHeaderBar, Tabs } from "../../TabHeader";
import { TabLink } from "../../TabLink";
import { Container, HeaderActions, SearchField } from "../shared";
import { AuditLogsDestinations } from "./AuditLogsDestinations";
import { AuditLogsList } from "./AuditLogsList";

export function AuditLogsSettings() {
  const canReadAuditLogs = useHasAccess("tenant:audit_logs_read");
  const canManageDestinations = useHasAccess("tenant:audit_logs_manage");
  const [onLogs] = useRouteMatch(routes.settings.auditLogs.logs);
  const [onDestinations] = useRouteMatch(
    routes.settings.auditLogs.destinations
  );
  const { q } = useCurrentUrl(routes.settings.auditLogs.logs);
  const search = q ?? "";
  const setSearch = (next: string) =>
    navigate(null, { q: next }, { replace: true });
  if (!canReadAuditLogs) return null;
  return (
    <Container>
      <TabHeaderBar>
        <Tabs>
          <TabLink
            to={makeUrl(routes.settings.auditLogs.logs)}
            active={onLogs}
            icon="table"
            label="Audit logs"
          />
          {canManageDestinations && (
            <TabLink
              to={makeUrl(routes.settings.auditLogs.destinations)}
              active={onDestinations}
              icon="output"
              label="Destinations"
            />
          )}
        </Tabs>
        <HeaderActions>
          {onLogs && (
            <SearchField
              placeholder="Search by operation…"
              value={search}
              onChange={setSearch}
            />
          )}
          {canManageDestinations && onDestinations && (
            <ButtonLink
              size="l"
              icon="plus"
              to={makeUrl(routes.settings.auditLogs.destinations.new)}
              replace
            />
          )}
        </HeaderActions>
      </TabHeaderBar>
      <Switch>
        <Route path={routes.settings.auditLogs.logs}>
          <AuditLogsList />
        </Route>
        {canManageDestinations && (
          <Route path={routes.settings.auditLogs.destinations}>
            <AuditLogsDestinations />
          </Route>
        )}
        <Route path={routes.settings.auditLogs}>
          <RedirectToLogs />
        </Route>
      </Switch>
    </Container>
  );
}

function RedirectToLogs() {
  useEffect(() => {
    navigate(routes.settings.auditLogs.logs, undefined, { replace: true });
  }, []);
  return null;
}
